$(document).ready(function () {
  // Get the current URL path
  let currentPath = window.location.pathname;

  const countryMenuButton = document.querySelector(
    ".footer-countries-menu__button"
  );
  const countryMenu = document.querySelector(".footer-countries-menu__list");

  // Toggle the country menu on button click
  countryMenuButton.addEventListener("click", function () {
    countryMenu.classList.toggle("footer-countries-menu__list--active");
  });
  // Close the country menu if clicked outside
  document.addEventListener("click", function (event) {
    if (
      !countryMenuButton.contains(event.target) &&
      !countryMenu.contains(event.target)
    ) {
      countryMenu.classList.remove("footer-countries-menu__list--active");
    }
  });
  // Close the country menu when the user scrolls
  window.addEventListener("scroll", function () {
    countryMenu.classList.remove("footer-countries-menu__list--active");
  });
});
